var _DbNameValidator;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TABLE_PREFIX = 'table_';
var COLUMN_PREFIX = 'column_';

// From io.deephaven.db.tables.utils.DBNameValidator#DB_RESERVED_VARIABLE_NAMES
var DB_RESERVED_VARIABLE_NAMES = new Set(['in', 'not', 'i', 'ii', 'k']);

// From javax.lang.model.SourceVersion#keywords
var JAVA_KEYWORDS = new Set(['abstract', 'continue', 'for', 'new', 'switch', 'assert', 'default', 'if', 'package', 'synchronized', 'boolean', 'do', 'goto', 'private', 'this', 'break', 'double', 'implements', 'protected', 'throw', 'byte', 'else', 'import', 'public', 'throws', 'case', 'enum', 'instanceof', 'return', 'transient', 'catch', 'extends', 'int', 'short', 'try', 'char', 'final', 'interface', 'static', 'void', 'class', 'finally', 'long', 'strictfp', 'volatile', 'const', 'float', 'native', 'super', 'while', 'null', 'true', 'false']);

// The '$' character is not valid in Deephaven table and column names,
// yet it is treated as valid in the DbNameValidator Java class.
// TODO: Update the regexes once (or if) DH-19169 is merged.

// From io.deephaven.db.tables.utils.DBNameValidator#STERILE_TABLE_AND_NAMESPACE_REGEX
var STERILE_TABLE_AND_NAMESPACE_REGEX = /[^a-zA-Z0-9_$\-+@]/g;

// From io.deephaven.db.tables.utils.DBNameValidator#STERILE_COLUMN_AND_QUERY_REGEX
var STERILE_COLUMN_AND_QUERY_REGEX = /[^A-Za-z0-9_$]/g;

// From io.deephaven.db.tables.utils.DBNameValidator#TABLE_NAME_PATTERN
var TABLE_NAME_PATTERN = /^[a-zA-Z_$][a-zA-Z0-9_$\-+@]*$/;
var STERILE_VARIABLE_NAME_REGEX = /[^a-zA-Z0-9_]/g;
function columnNameReplacer(input) {
  // Replace all dashes and spaces with underscores
  return input.replace(/[ -]/g, '_');
}
function tableNameReplacer(input) {
  // Replace spaces with underscores
  return input.replace(/\s/g, '_');
}

/**
 * Similar to DBNameValidator.java, this class has utilities for validating and legalizing
 * Table and Column names.
 */
class DbNameValidator {}
_DbNameValidator = DbNameValidator;
_defineProperty(DbNameValidator, "legalize", (name, replace, prefix, regex, checkReserved, i) => {
  var legalName = replace(name.trim());

  // Add prefix to reserved names
  if (checkReserved && (DB_RESERVED_VARIABLE_NAMES.has(legalName) || JAVA_KEYWORDS.has(legalName))) {
    legalName = prefix + legalName;
  }

  // Remove illegal characters
  legalName = legalName.replace(regex, '');

  // Check if the name ended up blank and append the prefix.
  // Note, io.deephaven.db.tables.utils.DBNameValidator throws an exception in this case.
  if (!legalName) {
    return prefix + i;
  }

  // If name starts with a number or a dash, append the prefix.
  // Note, io.deephaven.db.tables.utils.DBNameValidator throws an exception for names starting with a dash.
  if (/^[0-9-]/.test(legalName)) {
    legalName = prefix + legalName;
  }
  return legalName;
});
/**
 * Get a legal table name based on the passed in string.
 * Follows the same rules as DBNameValidator.java except that here
 * we prepend a prefix in cases where the Java class throws an exception.
 * @param name The name to legalize
 * @returns Legalized table name
 */
_defineProperty(DbNameValidator, "legalizeTableName", name => _DbNameValidator.legalize(name, tableNameReplacer, TABLE_PREFIX, STERILE_TABLE_AND_NAMESPACE_REGEX, false, 0));
/**
 * Make a valid variable name based on the passed in string.
 * @param name The name to get the variable name for
 * @returns Variable name
 */
_defineProperty(DbNameValidator, "makeVariableName", name => _DbNameValidator.legalizeTableName(name).replace(STERILE_VARIABLE_NAME_REGEX, '_'));
_defineProperty(DbNameValidator, "legalizeColumnNames", headers => {
  var legalHeaders = [];
  headers.forEach((header, i) => {
    var legalHeader = _DbNameValidator.legalizeColumnName(header, i);

    // Check if the name is already in use
    if (legalHeaders.includes(legalHeader)) {
      legalHeader = COLUMN_PREFIX + i;
    }
    legalHeaders.push(legalHeader);
  });
  return legalHeaders;
});
_defineProperty(DbNameValidator, "legalizeColumnName", function (header) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return (
    // Replace all dashes and spaces with underscores
    _DbNameValidator.legalize(header, columnNameReplacer, COLUMN_PREFIX, STERILE_COLUMN_AND_QUERY_REGEX, true, i)
  );
});
_defineProperty(DbNameValidator, "isValidTableName", name => TABLE_NAME_PATTERN.test(name));
_defineProperty(DbNameValidator, "isValidColumnName", name => _DbNameValidator.legalizeColumnName(name) === name);
export default DbNameValidator;
//# sourceMappingURL=DbNameValidator.js.map